import { FC } from 'react';
import UsersLeaderboardContainer from '@components/play/mainLeaderboard/usersLeaderboardContainer';
import styles from './tournamentLeaderboard.module.scss';

const TournamentLeaderboard: FC<{ tournamentUuid: string }> = (props: { tournamentUuid: string }) => {
    const { tournamentUuid } = props;
    return (
        <div className={styles.wrapper}>
            <div className={styles.leaderboard}>
                <UsersLeaderboardContainer isTournament tournamentUuid={tournamentUuid} />
            </div>
        </div>
    );
};

export default TournamentLeaderboard;
